<template>
    <div>
        <v-container grid-list-md fluid>
            <v-layout wrap>
                <v-flex xs12 sm5>
                    <v-btn-back
                        @click.stop="back()"
                        v-if="mode !== 'GeneralLedger' && goBackHistory"
                        data-cy="document-back"
                    />
                    <div
                        style="
                            position: relative;
                            width: 100%;
                            height: 0;
                            padding: 0;
                            padding-bottom: 141.4516129032258%;
                            margin-bottom: 50px;
                        "
                    >
                        <svg
                            id="svg-document-validation-management"
                            v-if="document"
                            xmlns="http://www.w3.org/2000/svg"
                            width="100%"
                            :viewBox="`0 0 ${imageWidth} ${imageHeight}`"
                            style="position: absolute; width: 100%; left: 0; top: 0"
                        >
                            <g>
                                <image
                                    id="svg-image-document-validation-management"
                                    :xlink:href="document.signedUrl"
                                    x="0"
                                    y="0"
                                    :height="`${imageHeight}px`"
                                    :width="`${imageWidth}px`"
                                />
                                <template
                                    v-for="(variant, index) in svgVariants"
                                    :key="`coord-${document.id}-${index}`"
                                >
                                    <template
                                        v-for="(coord, index2) in variant.coordinates"
                                        :key="`coord-${document.id}-${index}-${index2}`"
                                    >
                                        <polygon
                                            :ref="`variants-${index}-${index2}`"
                                            :points="getPoints(coord)"
                                            :style="
                                                variant.active
                                                    ? 'fill:rgba(250,250,250,0.5);stroke:lime;stroke-width:1'
                                                    : 'fill:rgba(250,250,250,0.5);stroke:gray;stroke-width:1;cursor:pointer'
                                            "
                                            @click.stop="
                                                variant.active
                                                    ? ''
                                                    : showCorrespondingField(variant, index, index2)
                                            "
                                            :class="variant.focus ? 'highlighted' : ''"
                                        />
                                    </template>
                                </template>
                            </g>
                        </svg>
                    </div>
                </v-flex>
                <v-list v-if="associatedFields.show" :style="svgPosition">
                    <v-list-item
                        v-for="(field, key, index) in associatedFields.fields"
                        :key="`field-${document.id}-${key}-${index}`"
                        @click="onFieldAssociation(field, key)"
                        class="oss-list-item"
                    >
                    </v-list-item>
                </v-list>
                <v-flex xs12 sm7 class="my-0">
                    <v-card class="default_card_wm" tile>
                        <!-- <v-card
                    style="position: fixed; margin-top: -3vh; max-height: 80vh; overflow-y: auto"
                    class="default_card_wm"
                    tile
                    > -->
                        <!-- <v-card
                    class="default_card_wm"
                    tile
                    > -->
                        <v-card-title style="padding-bottom: 0; padding-top: 5px">
                            <h3>Valider le justificatif</h3>
                            <v-spacer />
                            <v-btn-icon
                                icon="$cloud_download"
                                color="secondary"
                                @click="startDownloadFile"
                            />

                            <v-btn-icon
                                icon="$oss-scan"
                                color="secondary"
                                @click="analyseDocumentDialog = true"
                                v-if="restartAnalysis"
                            />
                            <v-btn-icon
                                icon="$delete"
                                @click="deleteDocumentDialog = true"
                                :disabled="disabledDelete"
                                :input-value="!disabledDelete"
                                color="error"
                            />
                        </v-card-title>
                        <v-card-text>
                            <v-card style="background-color: transparent" elevation="0">
                                <v-card-title
                                    class="title font-weight-regular justify-space-between"
                                >
                                    <span>{{ wizardStepTitle }}</span>
                                    <v-avatar
                                        color="primary lighten-2"
                                        class="subheading white--text"
                                        size="24"
                                        v-text="wizardStep"
                                    />
                                </v-card-title>
                                <v-window
                                    v-model="wizardStep"
                                    touchless
                                    style="min-height: 27vh"
                                    v-if="form.date"
                                >
                                    <v-window-item :value="1">
                                        <v-card-text class="py-0">
                                            <v-list>
                                                <v-list-item
                                                    v-for="(type, i) in documentTypeItems"
                                                    :key="i"
                                                    :class="geDocumentTypeClass(type.type)"
                                                    @click.stop="document.type = type.type"
                                                >
                                                    <template #prepend>
                                                        <v-icon :class="type.iconClass">{{
                                                            type.icon
                                                        }}</v-icon>
                                                    </template>

                                                    <template v-slot:append>
                                                        <v-btn>
                                                            <v-icon color="primary">{{
                                                                document.type === type.type
                                                                    ? "$radio_button_checked"
                                                                    : "$radio_button_unchecked"
                                                            }}</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <v-list-item-title>{{
                                                        type.title
                                                    }}</v-list-item-title></v-list-item
                                                >
                                            </v-list>
                                            <!-- <v-row justify="space-around">
                                                <v-radio-group v-model="document.type" class="mt-0">
                                                    <v-radio
                                                        :label="$t('document.choiceType.PURCHASE_INVOICE')"
                                                        value="PURCHASE_INVOICE"
                                                        color="secondary"
                                                    ></v-radio>
                                                    <v-radio
                                                        :label="$t('document.choiceType.SALES_INVOICE')"
                                                        value="SALES_INVOICE"
                                                        color="secondary"
                                                    ></v-radio>
                                                    <v-radio
                                                        :label="$t('document.choiceType.CURRENT_ACCOUNT')"
                                                        value="CURRENT_ACCOUNT"
                                                        color="secondary"
                                                        v-if="legalForm !== 'EI'"
                                                    ></v-radio>
                                                    <v-radio
                                                        :label="$t('document.choiceType.OPERATOR_ACCOUNT')"
                                                        value="OPERATOR_ACCOUNT"
                                                        color="secondary"
                                                        v-else
                                                    ></v-radio>
                                                </v-radio-group>
                                            </v-row> -->
                                        </v-card-text>
                                    </v-window-item>
                                    <v-window-item :value="8">
                                        <v-card-text class="py-0">
                                            <SelectUser
                                                v-bind:companyId="companyId"
                                                v-bind:selectedUser="currentAccountUser"
                                                @user-selected="onUserSelected"
                                                v-if="wizardStep === 8"
                                            >
                                            </SelectUser>
                                            <!-- <v-row justify="space-around">
                                                <v-select
                                                    :items="currentAccountUsers"
                                                    :item-title="getUserDisplayName"
                                                    item-value="id"
                                                    label="Associé"
                                                    style="margin: 0 auto"
                                                    v-model="currentAccountUser"
                                                    return-object
                                                    outlined
                                                    :rules="currentAccountUserRules"
                                                    :success="checkCurrentAccountUser"
                                                    :error="!checkCurrentAccountUser"
                                                    v-if="document.type === 'CURRENT_ACCOUNT' || document.type === 'OPERATOR_ACCOUNT'"
                                                ></v-select>
                                            </v-row> -->
                                        </v-card-text>
                                    </v-window-item>
                                    <v-window-item :value="2">
                                        <v-card-text class="py-0">
                                            <v-row justify="space-around">
                                                <v-radio-group
                                                    v-model="document.creditNote"
                                                    color="primary"
                                                >
                                                    <v-radio
                                                        label="Non"
                                                        color="secondary"
                                                        :model-value="false"
                                                    />
                                                    <v-radio
                                                        label="Oui"
                                                        color="secondary"
                                                        :model-value="true"
                                                    />
                                                </v-radio-group>
                                            </v-row>
                                        </v-card-text>
                                    </v-window-item>
                                    <v-window-item :value="3">
                                        <v-card-text class="py-0">
                                            <v-flex class="text-center mb-2">
                                                <v-card
                                                    class="default_card_wm mx-auto"
                                                    style="
                                                        background: #fff !important;
                                                        box-shadow: none;
                                                    "
                                                    v-if="document.thirdPartyCompany"
                                                >
                                                    <v-card-title primary-title class="py-0">
                                                        <div>
                                                            {{
                                                                document.thirdPartyCompany
                                                                    ? document.thirdPartyCompany
                                                                          .name
                                                                    : ""
                                                            }}
                                                        </div>
                                                    </v-card-title>
                                                    <v-card-text
                                                        class="text-left pb-0"
                                                        v-if="document.thirdPartyCompany.siret"
                                                    >
                                                        Siret :
                                                        {{
                                                            getSiretValue(
                                                                document.thirdPartyCompany.siret,
                                                            )
                                                        }}
                                                    </v-card-text>
                                                </v-card>
                                            </v-flex>
                                            <v-flex
                                                class="text-center mb-2"
                                                v-if="
                                                    document.type === 'SALES_INVOICE' && !consumer
                                                "
                                            >
                                                <v-btn
                                                    @click="consumer = true"
                                                    class="btn"
                                                    rounded
                                                    size="small"
                                                >
                                                    Le client est un particulier
                                                </v-btn>
                                            </v-flex>
                                            <v-flex class="text-center mb-0">
                                                <v-btn
                                                    @click="dialogSelectCompany = true"
                                                    class="btn"
                                                    rounded
                                                    size="small"
                                                    >{{ otherThirdPartyCompany }}
                                                </v-btn>
                                            </v-flex>
                                        </v-card-text>
                                    </v-window-item>
                                    <v-window-item :value="9">
                                        <v-card-text class="py-0">
                                            <v-combobox-filled
                                                :items="invoiceNumberList"
                                                :rules="[form.invoiceNumber.validated || '']"
                                                @update:model-value="
                                                    onDateChange(
                                                        form.invoiceNumber,
                                                        'invoiceNumber',
                                                        $event,
                                                    )
                                                "
                                                @keyup.enter="
                                                    onDateChange(
                                                        form.invoiceNumber,
                                                        'invoiceNumber',
                                                        $event,
                                                    )
                                                "
                                                @mouseover.native="
                                                    highlightField(form.invoiceNumber, true)
                                                "
                                                @mouseout.native="
                                                    highlightField(form.invoiceNumber, false)
                                                "
                                                outlined
                                                :hide-details="true"
                                                :model-value="form.invoiceNumber.value"
                                            />
                                        </v-card-text>
                                    </v-window-item>
                                    <v-window-item :value="4">
                                        <v-card-text class="py-0">
                                            <v-combobox-filled
                                                :items="dateList"
                                                :rules="dateRules"
                                                :prepend-inner-icon="'$vuetify.icons.calendar'"
                                                @update:model-value="
                                                    onDateChange(form['date'], 'date', $event)
                                                "
                                                @keyup.enter="
                                                    onDateChange(form['date'], 'date', $event)
                                                "
                                                @click:prepend-inner="dateDialog = !dateDialog"
                                                @mouseover.native="
                                                    highlightField(form['date'], true)
                                                "
                                                @mouseout.native="
                                                    highlightField(form['date'], false)
                                                "
                                                outlined
                                                required
                                                dense
                                                :model-value="formatObjectDate(form.date)"
                                            />
                                        </v-card-text>
                                    </v-window-item>
                                    <v-window-item :value="5">
                                        <v-card-text class="py-0">
                                            <v-date-picker-wrapper
                                                locale="fr-FR"
                                                v-model="dueDate"
                                                full-width
                                                :landscape="!$vuetify.display.mobile"
                                                class="elevation-0"
                                                color="secondary"
                                                scrollable
                                            />
                                        </v-card-text>
                                    </v-window-item>
                                    <v-window-item :value="6">
                                        <v-card-text class="pa-0">
                                            <div v-if="subjectToVAT">
                                                <v-flex>
                                                    <v-switch
                                                        v-model="multiVat"
                                                        :label="'Multi TVA'"
                                                        class="pl-2"
                                                    />
                                                    <!-- <div xs12 style="display:flex;" v-if="showVATType()">
                                                        <v-radio-group
                                                        label="Type de TVA"
                                                        v-model="document.vatType"
                                                        :rules="[ !!document.vatType || 'Type de VAT requise']"
                                                        inline
                                                        required>
                                                            <v-radio label="Aucun" value="NO_VAT_TYPE" color="secondary" v-if="document.type !=='SALES_INVOICE'"></v-radio>
                                                            <v-radio label="Intracom" value="INTRACOM" color="secondary"></v-radio>
                                                            <v-radio label="Export" value="EXPORT"  color="secondary" v-if="document.type ==='SALES_INVOICE'"></v-radio>
                                                            <v-radio label="Import" value="IMPORT"  color="secondary" v-else></v-radio>
                                                            <v-radio label="Autoliquidation" value="REVERSE_CHARGE"  color="secondary"></v-radio>
                                                        </v-radio-group>
                                                    </div> -->

                                                    <div
                                                        xs12
                                                        style="display: flex"
                                                        class="oss-grind"
                                                    >
                                                        <v-flex xs3 class="pa-0">
                                                            <oss-text-field
                                                                @update:model-value="
                                                                    onMetadataChange(
                                                                        form.single_prices.prices,
                                                                        '',
                                                                        'netAmount',
                                                                    )
                                                                "
                                                                @mouseover="
                                                                    highlightField(
                                                                        form.single_prices.prices
                                                                            .netAmount,
                                                                        true,
                                                                    )
                                                                "
                                                                @mouseout="
                                                                    highlightField(
                                                                        form.single_prices.prices
                                                                            .netAmount,
                                                                        false,
                                                                    )
                                                                "
                                                                :color="
                                                                    priceTextColor_amountData(
                                                                        form.single_prices.prices,
                                                                        true,
                                                                    )
                                                                "
                                                                :rules="[
                                                                    form.allPricesValidated || '',
                                                                ]"
                                                                :readonly="multiVat"
                                                                regular
                                                                outlined
                                                                dense
                                                                content-class="mr-1"
                                                                :hide-details="true"
                                                                v-model="
                                                                    form.single_prices.prices
                                                                        .netAmount.value
                                                                "
                                                            >
                                                                <template #label>
                                                                    HT
                                                                    <span
                                                                        v-if="
                                                                            confidence(
                                                                                form.single_prices
                                                                                    .prices
                                                                                    .netAmount,
                                                                            )
                                                                        "
                                                                    >
                                                                        (
                                                                        <span
                                                                            :class="
                                                                                confidence(
                                                                                    form
                                                                                        .single_prices
                                                                                        .prices
                                                                                        .netAmount,
                                                                                ) > 80
                                                                                    ? 'text-green'
                                                                                    : 'text-red'
                                                                            "
                                                                            >{{
                                                                                `${confidence(
                                                                                    form
                                                                                        .single_prices
                                                                                        .prices
                                                                                        .netAmount,
                                                                                )}%`
                                                                            }}</span
                                                                        >)
                                                                    </span>
                                                                </template>
                                                            </oss-text-field>
                                                        </v-flex>
                                                        <v-flex xs3 class="pa-0">
                                                            <oss-text-field
                                                                @update:model-value="
                                                                    onMetadataChange(
                                                                        form.single_prices.prices,
                                                                        '',
                                                                        'vatAmount',
                                                                    )
                                                                "
                                                                @mouseover="
                                                                    highlightField(
                                                                        form.single_prices.prices
                                                                            .vatAmount,
                                                                        true,
                                                                    )
                                                                "
                                                                @mouseout="
                                                                    highlightField(
                                                                        form.single_prices.prices
                                                                            .vatAmount,
                                                                        false,
                                                                    )
                                                                "
                                                                :color="
                                                                    priceTextColor_amountData(
                                                                        form.single_prices.prices,
                                                                        true,
                                                                    )
                                                                "
                                                                :rules="[
                                                                    form.allPricesValidated || '',
                                                                ]"
                                                                :readonly="multiVat"
                                                                regular
                                                                dense
                                                                content-class="mr-1"
                                                                :hide-details="true"
                                                                outlined
                                                                v-model="
                                                                    form.single_prices.prices
                                                                        .vatAmount.value
                                                                "
                                                            >
                                                                <template #label>
                                                                    TVA
                                                                    <span
                                                                        v-if="
                                                                            confidence(
                                                                                form.single_prices
                                                                                    .prices
                                                                                    .vatAmount,
                                                                            )
                                                                        "
                                                                    >
                                                                        (
                                                                        <span
                                                                            :class="
                                                                                confidence(
                                                                                    form
                                                                                        .single_prices
                                                                                        .prices
                                                                                        .vatAmount,
                                                                                ) > 80
                                                                                    ? 'text-green'
                                                                                    : 'text-red'
                                                                            "
                                                                            >{{
                                                                                `${confidence(
                                                                                    form
                                                                                        .single_prices
                                                                                        .prices
                                                                                        .vatAmount,
                                                                                )}%`
                                                                            }}</span
                                                                        >)
                                                                    </span>
                                                                </template>
                                                            </oss-text-field>
                                                        </v-flex>
                                                        <v-flex xs3 class="pa-0">
                                                            <oss-text-field
                                                                @update:model-value="
                                                                    onMetadataChange(
                                                                        form.single_prices.prices,
                                                                        '',
                                                                        'grossAmount',
                                                                    )
                                                                "
                                                                @mouseover="
                                                                    highlightField(
                                                                        form.single_prices.prices
                                                                            .grossAmount,
                                                                        true,
                                                                    )
                                                                "
                                                                @mouseout="
                                                                    highlightField(
                                                                        form.single_prices.prices
                                                                            .grossAmount,
                                                                        false,
                                                                    )
                                                                "
                                                                :color="
                                                                    priceTextColor_amountData(
                                                                        form.single_prices.prices,
                                                                        true,
                                                                    )
                                                                "
                                                                :rules="[
                                                                    form.allPricesValidated || '',
                                                                ]"
                                                                :readonly="multiVat"
                                                                regular
                                                                dense
                                                                content-class="mr-1"
                                                                :hide-details="true"
                                                                outlined
                                                                v-model="
                                                                    form.single_prices.prices
                                                                        .grossAmount.value
                                                                "
                                                            >
                                                                <template #label>
                                                                    TTC
                                                                    <span
                                                                        v-if="
                                                                            confidence(
                                                                                form.single_prices
                                                                                    .prices
                                                                                    .grossAmount,
                                                                            )
                                                                        "
                                                                    >
                                                                        (
                                                                        <span
                                                                            :class="
                                                                                confidence(
                                                                                    form
                                                                                        .single_prices
                                                                                        .prices
                                                                                        .grossAmount,
                                                                                ) > 80
                                                                                    ? 'text-green'
                                                                                    : 'text-red'
                                                                            "
                                                                            >{{
                                                                                `${confidence(
                                                                                    form
                                                                                        .single_prices
                                                                                        .prices
                                                                                        .grossAmount,
                                                                                )}%`
                                                                            }}</span
                                                                        >)
                                                                    </span>
                                                                </template>
                                                            </oss-text-field>
                                                        </v-flex>

                                                        <v-flex class="pa-0 xs3">
                                                            <v-select-filled
                                                                :items="vatList"
                                                                :color="
                                                                    priceTextColor_amountData(
                                                                        form.single_prices.prices,
                                                                        true,
                                                                    )
                                                                "
                                                                :rules="[
                                                                    form.allPricesValidated || '',
                                                                ]"
                                                                @update:model-value="
                                                                    onVatRateChange(
                                                                        form.single_prices.prices,
                                                                        $event,
                                                                    )
                                                                "
                                                                @mouseover.native="
                                                                    highlightField(
                                                                        form.single_prices.prices
                                                                            .vatRate,
                                                                        true,
                                                                    )
                                                                "
                                                                @mouseout.native="
                                                                    highlightField(
                                                                        form.single_prices.prices
                                                                            .vatRate,
                                                                        false,
                                                                    )
                                                                "
                                                                regular
                                                                class="mr-1"
                                                                :hide-details="true"
                                                                v-show="!multiVat"
                                                                outlined
                                                                :model-value="
                                                                    vatList.find(
                                                                        (el) =>
                                                                            el.value ===
                                                                            form.single_prices
                                                                                .prices.vatRate
                                                                                .value,
                                                                    )
                                                                        ? form.single_prices.prices
                                                                              .vatRate.value
                                                                        : 0
                                                                "
                                                                density="compact"
                                                            />
                                                        </v-flex>
                                                        <v-flex xs3 class="pa-0" v-show="multiVat">
                                                            <div
                                                                style="
                                                                    min-width: 100px;
                                                                    min-height: 50px;
                                                                "
                                                            />
                                                        </v-flex>
                                                        <v-flex xs1 class="pa-0">
                                                            <div class="inline-icon">
                                                                <!-- <v-icon
                                                                    :color="form.allPricesValidated ? 'green' : 'red'"
                                                                    @click="onPricesValidation()"
                                                                >{{ form.allPricesValidated ? '$check_box' : '$check_box_outline_blank' }}</v-icon> -->
                                                                <v-icon
                                                                    color="blue"
                                                                    @click="
                                                                        toggleLink(
                                                                            form.single_prices
                                                                                .prices,
                                                                        )
                                                                    "
                                                                    v-if="!multiVat"
                                                                    >{{
                                                                        form.single_prices.prices
                                                                            .link
                                                                            ? "$link"
                                                                            : "$link_off"
                                                                    }}</v-icon
                                                                >
                                                            </div>
                                                        </v-flex>
                                                    </div>

                                                    <template v-if="multiVat">
                                                        <div
                                                            xs3
                                                            style="display: flex"
                                                            v-for="index in [1, 2, 3]"
                                                            class="oss-grind"
                                                            :key="`vat_${index}`"
                                                        >
                                                            <v-flex xs3 class="pa-0">
                                                                <oss-text-field
                                                                    @update:model-value="
                                                                        onMetadataChange(
                                                                            form.multi_prices[
                                                                                `prices_${index}`
                                                                            ],
                                                                            `_${index}`,
                                                                            `netAmount_${index}`,
                                                                        )
                                                                    "
                                                                    @mouseover="
                                                                        highlightField(
                                                                            form.multi_prices[
                                                                                `prices_${index}`
                                                                            ][`netAmount_${index}`],
                                                                            true,
                                                                        )
                                                                    "
                                                                    @mouseout="
                                                                        highlightField(
                                                                            form.multi_prices[
                                                                                `prices_${index}`
                                                                            ][`netAmount_${index}`],
                                                                            false,
                                                                        )
                                                                    "
                                                                    :color="
                                                                        priceTextColor(
                                                                            form.multi_prices[
                                                                                `prices_${index}`
                                                                            ],
                                                                            `_${index}`,
                                                                        )
                                                                    "
                                                                    :rules="[
                                                                        areRowPricesValidated(
                                                                            form.multi_prices[
                                                                                `prices_${index}`
                                                                            ],
                                                                            `_${index}`,
                                                                        ) || '',
                                                                    ]"
                                                                    regular
                                                                    dense
                                                                    content-class="mr-1 mb-1"
                                                                    :hide-details="true"
                                                                    outlined
                                                                    v-model="
                                                                        form.multi_prices[
                                                                            `prices_${index}`
                                                                        ][`netAmount_${index}`]
                                                                            .value
                                                                    "
                                                                >
                                                                    <template #label>
                                                                        HT {{ index }}
                                                                        <span
                                                                            v-if="
                                                                                confidence(
                                                                                    subAmount.netAmount,
                                                                                )
                                                                            "
                                                                        >
                                                                            (
                                                                            <span
                                                                                :class="
                                                                                    confidence(
                                                                                        subAmount.netAmount,
                                                                                    ) > 80
                                                                                        ? 'text-green'
                                                                                        : 'text-red'
                                                                                "
                                                                                >{{
                                                                                    `${confidence(
                                                                                        subAmount.netAmount,
                                                                                    )}%`
                                                                                }}</span
                                                                            >)
                                                                        </span>
                                                                    </template>
                                                                </oss-text-field>
                                                            </v-flex>

                                                            <v-flex xs3 class="pa-0">
                                                                <oss-text-field
                                                                    @update:model-value="
                                                                        onMetadataChange(
                                                                            form.multi_prices[
                                                                                `prices_${index}`
                                                                            ],
                                                                            `_${index}`,
                                                                            `vatAmount_${index}`,
                                                                        )
                                                                    "
                                                                    @mouseover="
                                                                        highlightField(
                                                                            form.multi_prices[
                                                                                `prices_${index}`
                                                                            ][`vatAmount_${index}`],
                                                                            true,
                                                                        )
                                                                    "
                                                                    @mouseout="
                                                                        highlightField(
                                                                            form.multi_prices[
                                                                                `prices_${index}`
                                                                            ][`vatAmount_${index}`],
                                                                            false,
                                                                        )
                                                                    "
                                                                    :color="
                                                                        priceTextColor(
                                                                            form.multi_prices[
                                                                                `prices_${index}`
                                                                            ],
                                                                            `_${index}`,
                                                                        )
                                                                    "
                                                                    :rules="[
                                                                        areRowPricesValidated(
                                                                            form.multi_prices[
                                                                                `prices_${index}`
                                                                            ],
                                                                            `_${index}`,
                                                                        ) || '',
                                                                    ]"
                                                                    regular
                                                                    dense
                                                                    content-class="mr-1 mb-1"
                                                                    :hide-details="true"
                                                                    outlined
                                                                    v-model="
                                                                        form.multi_prices[
                                                                            `prices_${index}`
                                                                        ][`vatAmount_${index}`]
                                                                            .value
                                                                    "
                                                                >
                                                                    <template #label>
                                                                        TVA {{ index }}
                                                                        <span
                                                                            v-if="
                                                                                confidence(
                                                                                    subAmount.vatAmount,
                                                                                )
                                                                            "
                                                                        >
                                                                            (
                                                                            <span
                                                                                :class="
                                                                                    confidence(
                                                                                        subAmount.vatAmount,
                                                                                    ) > 80
                                                                                        ? 'text-green'
                                                                                        : 'text-red'
                                                                                "
                                                                                >{{
                                                                                    `${confidence(
                                                                                        subAmount.vatAmount,
                                                                                    )}%`
                                                                                }}</span
                                                                            >)
                                                                        </span>
                                                                    </template>
                                                                </oss-text-field>
                                                            </v-flex>

                                                            <v-flex xs3 class="pa-0">
                                                                <oss-text-field
                                                                    @update:model-value="
                                                                        onMetadataChange(
                                                                            form.multi_prices[
                                                                                `prices_${index}`
                                                                            ],
                                                                            `_${index}`,
                                                                            `grossAmount_${index}`,
                                                                        )
                                                                    "
                                                                    @mouseover="
                                                                        highlightField(
                                                                            form.multi_prices[
                                                                                `prices_${index}`
                                                                            ][
                                                                                `grossAmount_${index}`
                                                                            ],
                                                                            true,
                                                                        )
                                                                    "
                                                                    @mouseout="
                                                                        highlightField(
                                                                            form.multi_prices[
                                                                                `prices_${index}`
                                                                            ][
                                                                                `grossAmount_${index}`
                                                                            ],
                                                                            false,
                                                                        )
                                                                    "
                                                                    :color="
                                                                        priceTextColor(
                                                                            form.multi_prices[
                                                                                `prices_${index}`
                                                                            ],
                                                                            `_${index}`,
                                                                        )
                                                                    "
                                                                    :rules="[
                                                                        areRowPricesValidated(
                                                                            form.multi_prices[
                                                                                `prices_${index}`
                                                                            ],
                                                                            `_${index}`,
                                                                        ) || '',
                                                                    ]"
                                                                    regular
                                                                    dense
                                                                    content-class="mr-1 mb-1"
                                                                    :hide-details="true"
                                                                    outlined
                                                                    v-model="
                                                                        form.multi_prices[
                                                                            `prices_${index}`
                                                                        ][`grossAmount_${index}`]
                                                                            .value
                                                                    "
                                                                >
                                                                    <template #label>
                                                                        TTC {{ index }}
                                                                        <span
                                                                            v-if="
                                                                                confidence(
                                                                                    subAmount.grossAmount,
                                                                                )
                                                                            "
                                                                        >
                                                                            (
                                                                            <span
                                                                                :class="
                                                                                    confidence(
                                                                                        subAmount.grossAmount,
                                                                                    ) > 80
                                                                                        ? 'text-green'
                                                                                        : 'text-red'
                                                                                "
                                                                                >{{
                                                                                    `${confidence(
                                                                                        subAmount.grossAmount,
                                                                                    )}%`
                                                                                }}</span
                                                                            >)
                                                                        </span>
                                                                    </template>
                                                                </oss-text-field>
                                                            </v-flex>

                                                            <v-flex class="pa-0 xs3">
                                                                <v-select-filled
                                                                    :items="vatList"
                                                                    :color="
                                                                        priceTextColor(
                                                                            form.multi_prices[
                                                                                `prices_${index}`
                                                                            ],
                                                                            `_${index}`,
                                                                        )
                                                                    "
                                                                    :rules="[
                                                                        areRowPricesValidated(
                                                                            form.multi_prices[
                                                                                `prices_${index}`
                                                                            ],
                                                                            `_${index}`,
                                                                        ) || '',
                                                                    ]"
                                                                    @update:model-value="
                                                                        onSelectChange(
                                                                            $event,
                                                                            form.multi_prices[
                                                                                `prices_${index}`
                                                                            ],
                                                                            `_${index}`,
                                                                            `vatRate_${index}`,
                                                                        )
                                                                    "
                                                                    @mouseover.native="
                                                                        highlightField(
                                                                            form.multi_prices[
                                                                                `prices_${index}`
                                                                            ][`vatRate_${index}`],
                                                                            true,
                                                                        )
                                                                    "
                                                                    @mouseout.native="
                                                                        highlightField(
                                                                            form.multi_prices[
                                                                                `prices_${index}`
                                                                            ][`vatRate_${index}`],
                                                                            false,
                                                                        )
                                                                    "
                                                                    regular
                                                                    class="mr-1 mb-1"
                                                                    :hide-details="true"
                                                                    outlined
                                                                    :model-value="
                                                                        vatList.findIndex(
                                                                            (el) =>
                                                                                el.value ===
                                                                                form.multi_prices[
                                                                                    `prices_${index}`
                                                                                ][
                                                                                    `vatRate_${index}`
                                                                                ].value,
                                                                        ) >= 0
                                                                            ? form.multi_prices[
                                                                                  `prices_${index}`
                                                                              ][`vatRate_${index}`]
                                                                                  .value
                                                                            : 0
                                                                    "
                                                                    density="compact"
                                                                />
                                                            </v-flex>
                                                            <v-flex xs1 class="pa-0">
                                                                <div class="inline-icon">
                                                                    <v-icon
                                                                        color="blue"
                                                                        @click="
                                                                            toggleFieldSync(
                                                                                `multiPrices_${index}`,
                                                                                index,
                                                                            )
                                                                        "
                                                                        v-if="multiVat"
                                                                        >{{
                                                                            getFieldSync(
                                                                                `multiPrices_${index}`,
                                                                            )
                                                                                ? "$link"
                                                                                : "$link_off"
                                                                        }}</v-icon
                                                                    >
                                                                </div>
                                                            </v-flex>
                                                        </div>
                                                    </template>
                                                </v-flex>
                                            </div>
                                            <!-- subjectToVAT = false (grossAmount validation only) -->
                                            <div v-else>
                                                <oss-text-field
                                                    @update:model-value="
                                                        onMetadataChange(
                                                            form.single_prices.prices,
                                                            '',
                                                            'grossAmount',
                                                        )
                                                    "
                                                    @mouseover="
                                                        highlightField(
                                                            form.single_prices.prices.grossAmount,
                                                            true,
                                                        )
                                                    "
                                                    @mouseout="
                                                        highlightField(
                                                            form.single_prices.prices.grossAmount,
                                                            false,
                                                        )
                                                    "
                                                    :color="
                                                        form.single_prices.prices.grossAmount
                                                            .validated
                                                            ? 'green'
                                                            : 'red'
                                                    "
                                                    :success="
                                                        form.single_prices.prices.grossAmount
                                                            .validated
                                                    "
                                                    :error="
                                                        !form.single_prices.prices.grossAmount
                                                            .validated
                                                    "
                                                    :rules="[
                                                        form.single_prices.prices.grossAmount
                                                            .validated || '',
                                                    ]"
                                                    regular
                                                    content-class="mr-1"
                                                    :hide-details="true"
                                                    outlined
                                                    dense
                                                    :append-outer-icon="
                                                        form.single_prices.prices.grossAmount
                                                            .validated
                                                            ? '$check_box'
                                                            : '$check_box_outline_blank'
                                                    "
                                                    @click:append-outer="
                                                        form.single_prices.prices.grossAmount.validated =
                                                            !form.single_prices.prices.grossAmount
                                                                .validated
                                                    "
                                                    v-model="
                                                        form.single_prices.prices.grossAmount.value
                                                    "
                                                >
                                                    <template #label>
                                                        TTC
                                                        <span
                                                            v-if="
                                                                confidence(
                                                                    form.single_prices.prices
                                                                        .grossAmount,
                                                                )
                                                            "
                                                        >
                                                            (
                                                            <span
                                                                :class="
                                                                    confidence(
                                                                        form.single_prices.prices
                                                                            .grossAmount,
                                                                    ) > 80
                                                                        ? 'text-green'
                                                                        : 'text-red'
                                                                "
                                                                >{{
                                                                    `${confidence(
                                                                        form.single_prices.prices
                                                                            .grossAmount,
                                                                    )}%`
                                                                }}</span
                                                            >)
                                                        </span>
                                                    </template>
                                                </oss-text-field>
                                            </div>
                                        </v-card-text>
                                    </v-window-item>
                                    <v-window-item :value="7">
                                        <v-card-text class="py-0">
                                            <v-list>
                                                <v-list-item
                                                    v-for="(vatType, i) in vatTypes"
                                                    :key="i"
                                                    :class="geVatTypeClass(vatType.value)"
                                                    @click.stop="document.vatType = vatType.value"
                                                >
                                                    <!-- <template
                                                    >
                                                    <v-icon
                                                    :class="type.iconClass"
                                                    >{{type.icon}}</v-icon>
                                                    </template> -->

                                                    <template v-slot:append>
                                                        <v-btn>
                                                            <v-icon color="primary">{{
                                                                document.vatType === vatType.value
                                                                    ? "$radio_button_checked"
                                                                    : "$radio_button_unchecked"
                                                            }}</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <v-list-item-title>{{
                                                        vatType.title
                                                    }}</v-list-item-title
                                                    ><v-list-item-subtitle>{{
                                                        vatType.description
                                                    }}</v-list-item-subtitle></v-list-item
                                                >
                                            </v-list>
                                            <!-- <v-radio-group
                                                label="Type de TVA"
                                                v-model="document.vatType"
                                                :rules="[ !!document.vatType || 'Type de VAT requise']"
                                                row
                                                required>
                                                    <v-radio label="Aucun" value="NO_VAT_TYPE" color="secondary" v-if="document.type !=='SALES_INVOICE'"></v-radio>
                                                    <v-radio label="Intracom" value="INTRACOM" color="secondary"></v-radio>
                                                    <v-radio label="Export" value="EXPORT"  color="secondary" v-if="document.type ==='SALES_INVOICE'"></v-radio>
                                                    <v-radio label="Import" value="IMPORT"  color="secondary" v-else></v-radio>
                                                    <v-radio label="Autoliquidation" value="REVERSE_CHARGE"  color="secondary"></v-radio>
                                            </v-radio-group> -->
                                        </v-card-text>
                                    </v-window-item>
                                </v-window>
                                <v-card-actions>
                                    <v-btn
                                        v-show="wizardStep > 1"
                                        rounded
                                        :disabled="disabledPrevStep()"
                                        @click="previousStep()"
                                        size="small"
                                    >
                                        Précédent
                                    </v-btn>
                                    <v-spacer />
                                    <v-btn
                                        rounded
                                        depressed
                                        :disabled="disabledNextStep()"
                                        @click="nextStep()"
                                        size="small"
                                    >
                                        Je valide
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <div class="text-center">
            <div class="bottom-sheet">
                <div class="remote">
                    <v-container class="controller" elevation-1 style="pointer-events: auto">
                        <v-btn
                            :disabled="zoomManager.disableZoomOut()"
                            class="btn elevation-0"
                            rounded="circle"
                            size="x-small"
                            @click.stop="zoomManager.zoomOut()"
                            icon="$zoom_out"
                        >
                        </v-btn>
                        <v-btn
                            :disabled="zoomManager.disableResetZoom()"
                            class="btn elevation-0"
                            rounded="circle"
                            size="x-small"
                            @click.stop="resetZoom()"
                            icon="$center_focus_weak"
                        >
                        </v-btn>
                        <v-btn
                            :disabled="zoomManager.disableZoomIn()"
                            class="btn elevation-0"
                            rounded="circle"
                            size="x-small"
                            @click.stop="zoomManager.zoomIn()"
                            icon="$zoom_in"
                        >
                        </v-btn>
                        <v-btn
                            :disabled="previousDisabled()"
                            class="btn elevation-0"
                            rounded
                            size="small"
                            @click="previous()"
                        >
                            <v-icon>$navigate_before</v-icon>
                            <span>Précédent</span>
                        </v-btn>
                        <v-btn
                            class="btn elevation-0"
                            rounded="circle"
                            size="x-small"
                            @click="stop()"
                            v-if="toBeDoneStatus"
                            icon="$stop"
                        >
                        </v-btn>
                        <v-btn
                            :disabled="nextDisabled()"
                            class="btn elevation-0"
                            rounded
                            @click="next()"
                            size="small"
                        >
                            <span>Suivant</span>
                            <v-icon>$navigate_next</v-icon>
                        </v-btn>

                        <!-- <v-btn
                            class="btn"
                            outlined
                             size="small"
                            color="secondary"
                            @click="setOpenChat('INFORMATION_REQUEST')"
                            v-if="selectedCompany.solution !== 'MANAGEMENT'"
                        >
                            <v-icon>$fa-comments</v-icon>
                            <span>Question</span>
                        </v-btn>
                        <v-btn
                            class="btn"
                            outlined
                             size="small"
                            color="secondary"
                            @click="setOpenChat('DENIED')"
                            v-if="selectedCompany.solution !== 'MANAGEMENT'"
                        >
                            <v-icon>report_problem</v-icon>
                            <span>Rejeter</span>
                        </v-btn> -->
                        <!-- <v-btn
                            class="btn"
                            outlined
                             size="small"
                            color="secondary"
                            @click="openReconciliation()"
                            v-if="activateReconciliation && selectedCompany.solution !== 'MANAGEMENT'"
                        >
                            <v-icon>$compare_arrows</v-icon>
                            <span>Rapprochement</span>
                        </v-btn> -->
                        <!-- <v-btn
                            class="btn"
                            outlined
                             size="small"
                            color="secondary"
                            :disabled="disabledValidate"
                            @click="onFormValidation()"
                        >
                            {{ validated ? 'Validé' : 'Valider' }}
                            <v-icon v-show="validated">$check</v-icon>
                        </v-btn> -->
                    </v-container>
                </div>
            </div>
        </div>
        <v-dialog
            ref="dateDialog"
            v-model="dateDialog"
            :return-value="form.date.value"
            persistent
            width="290px"
            v-if="form.date"
        >
            <v-date-picker-wrapper
                v-model="form.date.value"
                hide-header
                scrollable
                color="secondary"
                @update:modelValue="onDateChangeFromDatePicker()"
            >
                <v-btn rounded @click="dateDialog = false">Cancel</v-btn>
                <v-btn rounded @click="$refs.dateDialog.save(form.date.value)">OK</v-btn>
            </v-date-picker-wrapper>
        </v-dialog>
        <Chat
            v-if="openChat"
            v-bind:id="document.chat ? document.chat.id : ''"
            v-bind:inShowMessage="open_chat"
            v-bind:chatTitle="'Document'"
            v-bind:chatSubtitle="getChatSubTitle()"
            :showSmartChat="wishStatus !== 'DENIED'"
            @messageSent="onMessageSent($event)"
            @showMessageChanged="onShowMessageChanged($event)"
        />
        <!-- ThirdPartyCompany -->
        <oss-dialog
            v-model="dialogSelectCompany"
            :title="'Choisir une société'"
            v-if="dialogSelectCompany"
            width="1000px"
        >
            <company-table
                :showGenericCompany="document.type !== 'SALES_INVOICE'"
                :showConsumerCompanies="document.type === 'SALES_INVOICE'"
                :showCustomerCompanies="document.type === 'SALES_INVOICE'"
                :showSupplierCompanies="document.type !== 'SALES_INVOICE'"
                :foundCompanies="foundCompanies"
                :showExistingCompanies="false"
                :company="document.thirdPartyCompany ? document.thirdPartyCompany.name : ''"
                :siret="
                    document.thirdPartyCompany && document.thirdPartyCompany.siret
                        ? document.thirdPartyCompany.siret
                        : ''
                "
                :siren="
                    document.thirdPartyCompany && document.thirdPartyCompany.siren
                        ? document.thirdPartyCompany.siren
                        : ''
                "
                :vatNumber="
                    document.thirdPartyCompany && document.thirdPartyCompany.vatNumber
                        ? document.thirdPartyCompany.vatNumber
                        : ''
                "
                :parentCompanyId="selectedCompany.id"
                @select-company="companySelected"
            />
        </oss-dialog>
        <oss-dialog v-model="dialogChooseDownload" title="Télécharger le document" width="80vw">
            Voulez-vous télécharger le document original ou marqué (numéro de pièce + horodaté).

            <template v-slot:actions>
                <v-row no-gutters>
                    <v-col cols="6" class="pr-2">
                        <v-btn-primary
                            rounded
                            block
                            @click="
                                dialogChooseDownload = false;
                                downloadFile(true);
                            "
                            size="x-large"
                            >Original</v-btn-primary
                        >
                    </v-col>
                    <v-col cols="6" class="pl-2">
                        <v-btn-primary
                            rounded
                            block
                            @click="
                                dialogChooseDownload = false;
                                downloadFile(false);
                            "
                            size="x-large"
                            >Marqué</v-btn-primary
                        >
                    </v-col>
                </v-row>
            </template>
        </oss-dialog>
        <oss-dialog
            v-model="analyseDocumentDialog"
            title="Relancer l'analyse du document"
            @valid="analyseDocument"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir relancer l'analyse ?</h4>
        </oss-dialog>
        <oss-dialog
            v-model="deleteDocumentDialog"
            title="Supprimer le document"
            :error="true"
            @valid="deleteDocument"
            :validTitle="'Oui je suis sûr(e)'"
            :validLoading="deleteDocumentLoading"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir supprimer le document ?</h4>
        </oss-dialog>
        <!-- spread -->
        <oss-dialog
            v-model="spreadPurchaseDialog"
            title="Etaler le montant sur plusieurs mois"
            @valid="spreadAmount"
            :validLoading="loading"
            :validDisabled="!spreadValid"
            width="800px"
        >
            <v-form v-model="spreadValid">
                <v-layout wrap xs12>
                    <v-flex xs12>
                        Pour les charges supérieures à 1000 euros vous pouvez répartir le montant
                        sur plusieurs mois
                    </v-flex>
                    <v-flex xs12>
                        <v-switch v-model="activateSpreadAmount" label="Etaler" />
                    </v-flex>
                    <v-flex xs12 v-show="activateSpreadAmount">
                        <oss-date-picker
                            v-bind:label="$t('shared.spreadStartDate')"
                            v-model="spreadStartDate"
                            v-bind:minDate="spreadMinStartDate"
                            v-bind:maxDate="spreadMaxStartDate"
                            v-bind:type="'month'"
                            v-bind:format="'MM/YYYY'"
                        >
                        </oss-date-picker>
                    </v-flex>
                    <v-flex xs12 mt-4 v-show="activateSpreadAmount">
                        <v-slider
                            v-model="spreadMounthCount"
                            :thumb-size="24"
                            thumb-label="always"
                            label="Nombre de mois"
                            min="2"
                            max="12"
                            color="secondary"
                            show-ticks
                        />
                    </v-flex>
                </v-layout>
            </v-form>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import { getSiretValue } from "../../../src/services/companyServices";
import { DocumentValidationInvoiceBase } from "./DocumentValidationInvoiceBase";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component
export class DocumentValidationManagement extends DocumentValidationInvoiceBase {
    beforeMount() {
        this.svgSuffix = "document-validation-management";
    }

    get vatTypes() {
        // not vat accountable account (document)
        const vatTypes = [];
        if (this.document.type === "SALES_INVOICE") {
            vatTypes.push({
                value: "NO_VAT_TYPE",
                title: "Aucun",
                description: "Vente hors champ de la TVA",
            });
        } else {
            vatTypes.push({
                value: "NO_VAT_TYPE",
                title: "Aucun",
                description: "Achat hors champ de la TVA",
            });
        }
        if (this.document.type === "SALES_INVOICE") {
            vatTypes.push({
                value: "INTRACOM",
                title: "Intracom",
                description:
                    "Vente des biens ou des services à une société basée dans un autre pays de l’Union européenne",
            });
        } else {
            vatTypes.push({
                value: "INTRACOM",
                title: "Intracom",
                description:
                    "Achat des biens ou des services à une société basée dans un autre pays de l’Union européenne",
            });
        }
        if (this.document.type === "SALES_INVOICE") {
            vatTypes.push({
                value: "EXPORT",
                title: "Export",
                description:
                    "Vente des biens ou des services à une société basée en dehors d'un pays de l’Union européenne",
            });
        } else {
            vatTypes.push({
                value: "IMPORT",
                title: "Import",
                description:
                    "Achat des biens ou des services à une société basée en dehors d'un pays de l’Union européenne",
            });
        }
        // if (this.document.type === 'SALES_INVOICE') {
        vatTypes.push({
            value: "REVERSE_CHARGE",
            title: "Autoliquidation",
            description: "TVA est payé directement au client acheteur des biens ou des services",
        });
        // }
        return vatTypes;
    }

    geVatTypeClass(vatType) {
        let docClass = "mb-2 oss-list-item";
        if (this.$vuetify.display.mobile) {
            docClass += " px-2";
        }
        if (this.document.vatType === vatType) {
            docClass += " oss-list-item-selected";
        }
        return docClass;
    }

    getSiretValue(siret: string) {
        return getSiretValue(siret);
    }
}

export default toNative(DocumentValidationManagement);
</script>
<style scoped>
.oss-document-card {
    position: fixed;
    margin-top: -3vh;
    max-height: 80vh;
    overflow-y: auto;
}

@media (max-width: 1000px) {
    .oss-document-card {
        width: 55vw;
    }
}
@media (min-width: 600px) and (max-width: 1100px) {
    .oss-document-card {
        width: 55vw;
    }
    .oss-grind {
        display: block !important;
    }
    .oss-text-field {
        max-width: 48% !important;
        float: left !important;
    }
}
@media (min-width: 1100px) and (max-width: 1500px) {
    .oss-document-card {
        width: 42vw;
    }
}
@media (min-width: 1500px) {
    .oss-document-card {
        width: 43vw;
    }
}
</style>
